import deepMerge from 'deepmerge';
import type { WidgetConfigDefinition } from '@/domain/WidgetConfig';
import * as WidgetConfigDefinitionAssembler from '@/domain/assemblers/WidgetConfigDefinitionAssembler.ts';
import * as ECAPI from './EcommerceService.ts';
import type { ProductEnrichmentsDefinition } from '@/domain/Product.ts';
import * as ProductAssembler from '@/domain/assemblers/ProductAssembler.ts';

export async function getFavoritesConfig(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<WidgetConfigDefinition> {
  const config = await getGenericContent(
    market,
    channel,
    locale,
    'widget_favorites',
    cacheBurst
  );

  return WidgetConfigDefinitionAssembler.fromEcapiDto(config);
}

export async function getProductDetailsHeroConfig(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<WidgetConfigDefinition> {
  const config = await getGenericContent(
    market,
    channel,
    locale,
    'widget_product-details-hero',
    cacheBurst
  );

  return WidgetConfigDefinitionAssembler.fromEcapiDto(config);
}

export async function getProductListHeroBannerConfig(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<WidgetConfigDefinition> {
  const config = await getGenericContent(
    market,
    channel,
    locale,
    'widget_product-list-hero-banner',
    cacheBurst
  );

  return WidgetConfigDefinitionAssembler.fromEcapiDto(config);
}

export async function getProductListConfig(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<WidgetConfigDefinition> {
  const config = await getGenericContent(
    market,
    channel,
    locale,
    'widget_product-list',
    cacheBurst
  );

  return WidgetConfigDefinitionAssembler.fromEcapiDto(config);
}

export async function getProductEnrichmentsDefinition(
  market: string,
  channel: string,
  locale: string,
  cacheBurst?: boolean
): Promise<ProductEnrichmentsDefinition> {
  const config = await getGenericContent(
    market,
    channel,
    locale,
    'catalog_products',
    cacheBurst
  );

  return ProductAssembler.enrichmentsFromEcapiDto(config);
}

async function getGenericContent(
  market: string,
  channel: string,
  locale: string,
  contentId: string,
  cacheBurst?: boolean
): Promise<any> {
  const [defaultContent, localeContent] = await Promise.all([
    ECAPI.cms(market, channel, contentId, undefined, cacheBurst),
    ECAPI.cms(market, channel, contentId, locale, cacheBurst)
  ]);

  const overwriteMerge = (destinationArray: any[], sourceArray: any[]) =>
    sourceArray?.length === 0 ? destinationArray : sourceArray;

  const content = deepMerge(
    defaultContent?.payload ?? {},
    localeContent?.payload ?? {},
    { arrayMerge: overwriteMerge }
  );

  return content;
}
